<template>
  <div class="mt-6 flex items-center rounded-lg bg-white p-4 text-gray-900">
    <CheckCircleIcon class="h-6 w-6 text-green-500" />

    <p class="ml-2 text-sm font-normal">
      <slot />
    </p>
  </div>
</template>

<script setup lang="ts">
import { CheckCircleIcon } from '@heroicons/vue/20/solid';
</script>
